var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessLogisticsCompanyPostCode.country"),
                prop: "country",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.country,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "country", $$v)
                  },
                  expression: "form.country",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessLogisticsCompanyPostCode.state"),
                prop: "state",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.state,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "state", $$v)
                  },
                  expression: "form.state",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessLogisticsCompanyPostCode.suburb"),
                prop: "suburb",
              },
            },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.suburb,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "suburb", $$v)
                  },
                  expression: "form.suburb",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("BusinessLogisticsCompanyPostCode.postcode"),
                prop: "postcode",
              },
            },
            [
              _c("BjInputNumber", {
                attrs: { min: 0, "not-auto-zero": "" },
                model: {
                  value: _vm.form.postcode,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "postcode", $$v)
                  },
                  expression: "form.postcode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Label", prop: "label" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.label,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "label", $$v)
                  },
                  expression: "form.label",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "LabelSub", prop: "labelsub" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.labelsub,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "labelsub", $$v)
                  },
                  expression: "form.labelsub",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 22 } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Zone", prop: "zone" } },
            [
              _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                  clearable: "",
                },
                model: {
                  value: _vm.form.zone,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "zone", $$v)
                  },
                  expression: "form.zone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }